import React from 'react';
import {Field} from 'redux-form';
import {View, TouchableOpacity, StyleSheet, Platform, TextStyle} from 'react-native';

import {DeviceSize} from '../../../shared/theme/helpers';
import {Button} from '../../../shared/components/button';
import {BaseField, InputMaskTypes} from '../../../shared/components/baseField';
import {useStyles, StyleHelper, NamedStyles} from '../../../shared/hooks/styles';
import {Text} from '../../../shared/components/text';
import {LoginType} from '../../../shared/models/api';
import {Form} from '../../../shared/components/form';
import {formatIdentificator, formatLoginLabel} from '../formatters';

export interface Props {
  onSubmit: (e?: any) => void;
  onForgotPassword: () => void;
  isSessionExpired: boolean;
  loginType?: LoginType;
  submitting: boolean;
}
export default ({onSubmit, onForgotPassword, loginType, isSessionExpired, submitting}: Props) => {
  const styles = useStyles(createStyles);
  const mask =
    loginType === LoginType.PhoneNumber
      ? InputMaskTypes.tel
      : loginType === LoginType.EskNumber
      ? InputMaskTypes.card
      : InputMaskTypes.snils;

  return (
    <View style={styles.container}>
      {isSessionExpired ? (
        <Text style={styles.sessionExpiredText}>{'Ваша сессия была завершена.\n' + 'Авторизируйтесь повторно.'}</Text>
      ) : null}
      <Form style={styles.formWrapper} onSubmit={onSubmit}>
        <View
          style={[
            styles.fieldContainer,
            Platform.OS === 'web' ? styles.fieldContainerWithMargin : null,
            styles.withOpacity,
          ]}>
          <Field
            component={BaseField}
            label={formatLoginLabel(loginType)}
            type={loginType === LoginType.PhoneNumber ? 'phone' : 'text'}
            name='identificator'
            mask={mask}
            format={(v: any) => formatIdentificator(v, loginType)}
            disabled
          />
        </View>
        <View style={styles.fieldContainer}>
          <Field
            component={BaseField}
            label='Пароль'
            type='password'
            name='password'
            onSubmitEditing={onSubmit}
            autoFocus
          />
        </View>
        <TouchableOpacity testID='forgot-password-text-id' style={styles.forPass} onPress={onForgotPassword}>
          <Text style={styles.forgotText}>Забыли пароль?</Text>
        </TouchableOpacity>
        <Button
          id='login-enter'
          style={styles.buttonsContainer}
          type='primary'
          onPress={onSubmit}
          text='Войти'
          disabled={submitting}
        />
      </Form>
    </View>
  );
};

const fl = StyleSheet.flatten;

const createStyles = (styleHelper: StyleHelper): NamedStyles<any> => {
  const {theme, mediaOnly, platformOnly, align} = styleHelper;
  return {
    container: fl([
      {
        flexGrow: 1,
        flexShrink: 0,
      },
      mediaOnly(DeviceSize.desktop, {width: 300}, {width: 295}),
    ]),
    formWrapper: {
      flexGrow: 1,
      flexShrink: 0,
      alignSelf: 'stretch',
      alignItems: 'stretch',
      ...mediaOnly(DeviceSize.desktop, {width: 300, marginTop: 14}, {paddingTop: 18}),
    },
    mt8: platformOnly('web', {marginTop: 8}, {marginTop: align(8)}),
    fieldContainerWithMargin: {
      marginBottom: 20,
    },
    fieldContainer: {
      ...mediaOnly(DeviceSize.desktop, {}, {marginTop: 0, width: '100%'}),
    },
    buttonsContainer: fl([
      {
        alignSelf: 'center',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        marginTop: 'auto',
        marginBottom: 0,
      },
      mediaOnly(DeviceSize.desktop, {width: 240}, {width: 200}),
    ]),
    forPass: fl([
      {
        width: '100%',
        marginBottom: 24,
      },
      platformOnly('web', {marginTop: 8}, {marginTop: -5}),
    ]),
    forgotText: fl([
      mediaOnly(DeviceSize.desktop, theme.fonts.h6Light, theme.fonts.body) as TextStyle,
      {color: theme.input.labelText.color, textAlign: 'right'},
    ]),
    withOpacity: {opacity: 0.5},
    sessionExpiredText: {
      color: theme.color.primaryColor,
      ...mediaOnly(DeviceSize.desktop, theme.fonts.body, theme.fonts.bodySmallLight),
      width: '100%',
      marginTop: 5,
      marginBottom: -10,
    },
  };
};
